import instance, { ApiError } from '../../api/instance';
import { AxiosError, AxiosResponse } from 'axios';
import { CompanyLocation } from './locations.types';

const locationsApiPath = '/locations';

export const getLocations = async (): Promise<AxiosResponse<CompanyLocation[] & ApiError>> => {
  return instance.get<CompanyLocation[]>(locationsApiPath).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createLocation = async (data: CompanyLocation): Promise<AxiosResponse<CompanyLocation & ApiError>> => {
  return instance.post<CompanyLocation>(locationsApiPath, data).catch(e => e.response as AxiosError<ApiError> as never);
};

const locationApiPath = (locationCode: string) => `/locations/${locationCode}`;

export const getLocation = async ({
  locationCode,
}: {
  locationCode: string;
}): Promise<AxiosResponse<CompanyLocation & ApiError>> => {
  return instance
    .get<CompanyLocation>(locationApiPath(locationCode))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateLocation = async ({
  locationCode,
  data,
}: {
  locationCode: string;
  data: Partial<CompanyLocation>;
}): Promise<AxiosResponse<CompanyLocation & ApiError>> => {
  return instance
    .post<CompanyLocation>(locationApiPath(locationCode), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteLocation = async ({
  locationCode,
}: {
  locationCode: string;
}): Promise<AxiosResponse<CompanyLocation & ApiError>> => {
  return instance
    .delete<CompanyLocation>(locationApiPath(locationCode))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
